import * as React from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import { useNavigate } from "react-router-dom";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import configData from "../config.json";
import { GetSession, GetToken } from "../components/Session";

const SystemLogs = () => {
    const [columns, setColumns] = React.useState(null);
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    const levels = ["All", "Information", "Warning", "Error", "Critical"];
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const subTotals = [];
    let dr = JSON.parse(localStorage.getItem('EventLogDates'));
    if (dr !== null) {
        if (dr.start !== null) dr.start = new Date(dr.start);
        if (dr.end !== null) dr.end = new Date(dr.end);
    } else {
        let dt = new Date();
        dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: null };
        localStorage.setItem("EventLogDates", JSON.stringify(dr));
    }

    const rangeChanged = (event) => {
        ChangeRange(event.target.value, level);
    }

    const ChangeRange = (dr, l) => {
        setDateRange(dr);
        localStorage.setItem("EventLogDates", JSON.stringify(dr));
        var params = {
            FromDate: dr.start === null ? "2000-01-01T00:00:00Z" : dr.start.toISOString(),
            ToDate: dr.end === null ? "2050-01-01T00:00:00Z" : dr.end.toISOString(),
            Other: l
        };
        setLookupParams(encodeURI(JSON.stringify(params)));
    }

    const levelChanged = (event) => {
        setLevel(event.target.value);
        ChangeRange(dateRange, event.target.value);
    }

    const [dateRange, setDateRange] = React.useState(dr);
    const [level, setLevel] = React.useState("All");
    const [lookupParams, setLookupParams] = React.useState("");
    React.useEffect(() => {
        GetColumnDefs("SystemLogs", setColumns);
        GetPermissions(["ViewPrintEventLog"], setPermissions);
        ChangeRange(dateRange);
    }, [])


    if (permissions && !permissions.CanView) navigate("/");

    return (
        <div>
            <div style={{ paddingTop: "20px" }}>
                {permissions && permissions.CanView && <div className="row" style={{ padding: "5px 10px" }}>
                    <div className="col-md-4" style={{ marginLeft: "30px" }} >
                        <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged} />
                    </div>
                    <div className="col-md-3" style={{ paddingTop: "7px", marginLeft: "-70px" }} >
                        <label className="control-label">Level</label>
                        <DropDownList id="Level" data={levels} value={level} onChange={levelChanged} />
                    </div>
                </div>}
            </div>
            {columns && permissions && permissions.CanView && <DataGrid dataSource='apiv7/private/getlogs' columns={columns} permissions={permissions} params={lookupParams} keyField="Id" subTotals={subTotals}  />}
        </div>
    );

}

export default SystemLogs;